<template lang="pug">
  .Scene
    h1(:class="titleAnimation") 应用场景
    div
      .card(v-for="(item, index) in scenes" :style="cardStyle"
        :class="[scenesClass(item), contentAnimation, `animateDelay-${index}`]") {{ item }}
</template>

<script>
  import Mixin from "../../index.js";
  export default {
    name: "Scene",
    mixins: [Mixin],
    props: {scenes: {type: Array}},
    watch: {},
    computed: {
      cardStyle() {
        if (this.scenes.length > 3) {
          return {
            height: '300px',
          }
        }
      },
    },
    methods: {
      scenesClass(title) {
        const classList = {
          '数字城市': 'city',
          '数字教育': 'education',
          '数字旅游': 'travel',
          '数字医疗': 'treatment',
          '商圈': 'trading',
          '旅游': 'trip',
          '医疗': 'medicalTreatment',
          '交通': 'traffic',
          '基础教育': 'basisEducation',
          '学前教育': 'preprimaryEducation',
          '高等教育': 'higherEducation',
          '职业教育': 'vocationalEducation',
        }
        return classList[title]
      },
    },
    created() {
    },
    mounted() {
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .Scene {
    VStack(center, center)
    padding 100px 0 50px
    max-width 100%
    > div {
      HStack(center, center)
      max-width 1300px
    }
    .card {
      width 422px
      height 388px
      background-color rgba(0, 0, 0, .5)
      VStack(center, center)
      margin 0 35px
      color white
      font-size 36px
      FontSetting("Source Han Sans CN Normal")
      transition all .3s
      background-size auto 100%
      background-repeat no-repeat
      background-position center
      &:hover {
        background-size auto 120%
      }
    }
  }
  .city {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E5%9F%8E%E5%B8%822.png")
  }
  .education {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E6%95%99%E8%82%B2.png")
  }
  .travel {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E6%97%85%E6%B8%B8.png")
  }
  .treatment {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E5%8C%BB%E7%96%97.png")
  }
  .trading {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E5%95%86%E5%9C%88.png")
  }
  .trip {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%97%85%E6%B8%B8.png")
  }
  .medicalTreatment {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E5%8C%BB%E7%96%97.png")
  }
  .traffic {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E4%BA%A4%E9%80%9A.png")
  }
  .basisEducation {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%9C%BA%E6%99%AF%E5%9B%BE/%E5%9F%BA%E7%A1%80%E6%95%99%E8%82%B2.png")
  }
  .preprimaryEducation {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%9C%BA%E6%99%AF%E5%9B%BE/%E5%AD%A6%E5%89%8D%E6%95%99%E8%82%B2.png")
  }
  .higherEducation {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%9C%BA%E6%99%AF%E5%9B%BE/%E9%AB%98%E7%AD%89%E6%95%99%E8%82%B2.png")
  }
  .vocationalEducation {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%9C%BA%E6%99%AF%E5%9B%BE/%E8%81%8C%E4%B8%9A%E6%95%99%E8%82%B2.png")
  }
  @media (max-width ipadProScreenWidth) {
    .Scene {
      > div {
        width 100%
        max-width 100%
        HStack()
        overflow-x auto
        .card {
          flex-shrink 0
          background-size 100%
        }
      }
    }
  }
  @media (max-width screenWidth) {
    .Scene {
      padding 50px 0
      width 100vw
      > div {
        width 100%
        overflow auto
        HStack()
        .card {
          width 60%
          height 55vw !important
          flex-shrink 0
          margin 0 10px
        }
      }
    }
  }
</style>
